import { render } from "./thirdPage.vue?vue&type=template&id=6ac90f8a&scoped=true"
import script from "./thirdPage.vue?vue&type=script&lang=js"
export * from "./thirdPage.vue?vue&type=script&lang=js"

import "./thirdPage.vue?vue&type=style&index=0&id=6ac90f8a&scoped=true&lang=css"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac90f8a"]])

export default __exports__